import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import InvoiceList, { DispatchProps, OwnProps, StateProps } from './InvoiceList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getInvoices, getInvoicesCsv, getInvoicesSmall, getInvoicesTotal } from 'src/store/actions/invoice-actions';
import { getStudentsSmall } from 'src/store/actions/student-actions';
import { getDistrictsSmall } from 'src/store/actions/district-actions';
import { getVendorsSmall } from 'src/store/actions/vendor-actions';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { getProvidersSmall } from 'src/store/actions/provider-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { persistInvoice } from 'src/store/actions/invoice-actions';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { clearTotal } from '../../../../../../store/actions/invoice-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.invoices.data,
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        inProgress: state.invoices.inProgress,
        providers: selectNameProviders(state),
        serviceTypes: state.serviceTypes.data,
        inProgressCSV: state.invoices.inProgressCSV,
        agencyInfo: state.app.agencyInfo,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getInvoicesSmall(params)),
        getDataCsv: (params: QueryParams) => dispatch(getInvoicesCsv(params)),
        getDataTotal: (params: QueryParams) => dispatch(getInvoicesTotal(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        persistInvoice: (params: any, params2: any, params3: any) => dispatch(persistInvoice(params, params2, params3)),
        clearTotal: () => dispatch(clearTotal()),
    };
}

const InvoiceListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InvoiceList);

export default InvoiceListScreen;
